import { Util } from "Util";
import axios from "axios";
import { AutoPayment, CreditCards, PayByNewCard, PaymentCard, PayWithCard, StripeCustomer, StripeCustomerPaymentResponse, StripeCustomerResponse } from "models/CreditCard";

export class CreditCardService {

  public static async createStripeCustomer(StripeCustomer: StripeCustomer): Promise<StripeCustomerResponse<StripeCustomer>> {
    const ep = Util.apiAuthUrl("create-customer-stripes");
    const res = await axios.post<StripeCustomer, StripeCustomerResponse<StripeCustomer>>(ep, StripeCustomer);
    return res;
  }
  public static async updateAutoPayment(autoPayment: AutoPayment): Promise<StripeCustomerResponse<StripeCustomer>> {
    const ep = Util.apiAuthUrl("user/auto-payment-update");
    const res = await axios.post<StripeCustomer, StripeCustomerResponse<StripeCustomer>>(ep, autoPayment);
    return res;
  }

  public static async changeDefaultPaymentCard(paymentMethodId: string): Promise<StripeCustomerPaymentResponse<StripeCustomer>> {
    const ep = Util.apiAuthUrl("change-default-card");
    const res = await axios.post<{ paymentMethodId: string }, StripeCustomerPaymentResponse<StripeCustomer>>(ep, {
      paymentMethodId
    });
    return res;
  }

  public static async getPaymentMethods(): Promise<StripeCustomerPaymentResponse<StripeCustomer>> {
    const ep = Util.apiAuthUrl("get-payment-methods");
    const res = await axios.get<StripeCustomer, StripeCustomerPaymentResponse<StripeCustomer>>(ep);
    return res;
  }

  public static async getDefaultPaymentMethods(): Promise<StripeCustomerPaymentResponse<StripeCustomer>> {
    const ep = Util.apiAuthUrl("get-default-payment-methods");
    const res = await axios.get<StripeCustomer, StripeCustomerPaymentResponse<StripeCustomer>>(ep);
    return res;
  }

  public static async createAndAttchPaymentMethod(paymentCard: PaymentCard): Promise<StripeCustomerResponse<PaymentCard>> {
    const ep = Util.apiAuthUrl("create-attch-payment-method");
    const res = await axios.post<PaymentCard, StripeCustomerResponse<PaymentCard>>(ep, paymentCard);
    return res;
  }

  public static async deleteCustomerPaymentMethods(paymentMethodId: string): Promise<StripeCustomerPaymentResponse<StripeCustomer>> {
    const ep = Util.apiAuthUrl("delete-paymentMethods-customer");
    const res = await axios.post<{ paymentMethodId: string }, StripeCustomerPaymentResponse<StripeCustomer>>(ep, {
      paymentMethodId
    });
    return res;
  }

  public static async PayByCard(PayWithCard: PayWithCard): Promise<StripeCustomerResponse<PayWithCard>> {
    const ep = Util.apiAuthUrl("pay-with-card");
    const res = await axios.post<PaymentCard, StripeCustomerResponse<PaymentCard>>(ep, PayWithCard);
    return res;
  }
  public static async PayNewCard(PayByNewCard: PayByNewCard): Promise<StripeCustomerResponse<PayByNewCard>> {
    const ep = Util.apiAuthUrl("pay-with-new-card");
    const res = await axios.post<PaymentCard, StripeCustomerResponse<PaymentCard>>(ep, PayByNewCard);
    return res;
  }

  public static async getAttachedPaymentMethods(): Promise<StripeCustomerResponse<CreditCards>> {
    const ep = Util.apiAuthUrl("get-attch-payment-methods");
    const res = await axios.post<CreditCards, StripeCustomerResponse<CreditCards>>(ep);
    return res;
  }
}